import styled, { keyframes } from 'styled-components';

const livePulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  min-width: 208px;
  overflow: hidden;
  z-index: 10;

  @media (max-width: 600px) {
    top: 76px;
    bottom: auto;
    transform: none;
    right: 10px;
    min-width: 140px;
  }
`;

export const Title = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;

  @media (max-width: 600px) {
    font-size: 11px;
    margin-bottom: 4px;
  }
`;

export const LiveDot = styled.span`
  width: 6px;
  height: 6px;
  background: #0f0;
  border-radius: 50%;
  animation: ${livePulse} 1.5s ease-in-out infinite;
  box-shadow: 0 0 8px #0f0;
  flex-shrink: 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled.a`
  display: block;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  color: inherit;

  &:hover {
    background: rgba(255, 255, 255, 0.02);
    padding-left: 8px;
  }

  @media (max-width: 768px) {
    padding: 4px 0;

    &:nth-child(n + 6) {
      display: none;
    }
  }

  @media (max-height: 500px) and (orientation: landscape) {
    padding: 4px 0;
  }
`;

export const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const EventLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const EventRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const TokenLogoWrapper = styled.div`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
`;

export const TokenPlaceholder = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
`;

export const Wallet = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  color: rgba(100, 200, 255, 0.8);
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 600px) {
    font-size: 10px;
  }
`;

export const Amount = styled.div<{ $type: 'profit' | 'loss' }>`
  font-family: 'Share Tech Mono', monospace;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  color: ${({ $type }) => ($type === 'profit' ? '#5f5' : '#f55')};
  text-shadow: ${({ $type }) =>
    $type === 'profit' ? '0 0 10px rgba(80, 255, 80, 0.4)' : '0 0 10px rgba(255, 80, 80, 0.4)'};

  @media (max-width: 600px) {
    font-size: 11px;
  }
`;
